export const createCacheKey = (
  obj: any,
  keyName?: string,
  createShallowKey: boolean = true
) => {
  if (!keyName) keyName = "cacheKey";
  if (createShallowKey) {
    let key = keyName + ";";
    Object.keys(obj).forEach((x) => (key += ":" + x + "=" + Object(obj)[x]));
    return key;
  }
  return keyName + ";" + JSON.stringify(obj);
};
